<template>
  <main id="main" @click="closeAchievedMessage()">
    <Loading :isProcessing="isProcessing"></Loading>
    <div v-if="!isProcessing">
    <DiagCorpHeader
      :corpName="corpName"
      :corporateFeatureInfoLabels="corporateFeatureInfoLabels"
      :corporateSelectable="isAdmin"
      :manageCorpName="manageCorpName"
      :isAdmin="isAdmin"
      :isDiagAvailablePlan="isDiagAvailablePlan"
      @select-corporate="emitSelectCorpList"
    ></DiagCorpHeader>
    <div class="l-contents">
      <h1 class="l-pageTitle"><span class="l-pageLabel">小テスト</span>{{ roughDiagResult.roughDiag.title }}</h1>
      <div class="l-contentsBox">
        <div class="l-contentsSection">
          <p class="l-text" style="white-space: pre-line;">{{ roughDiagResult.roughDiag.description }}</p>
        </div>
        <div class="l-min-progress">
          <div class="answer_number">
            <p>達成率 {{ this.answeredCount }}/{{ this.totalCount }}<span>{{ progress }}％</span></p>
          </div>
          <div class="response">
            <div class="progress_bar"><span :style="('width: ' + progress + '%')"></span></div>
          </div>
        </div>
        <div v-for="roughDiagItem in roughDiagResult.roughDiag.roughDiagItems" :key="roughDiagItem.roughDiagItemId">
          <RoughDiagAnswerItem
            v-model="roughDiagItem.roughDiagResultItem.answer"
            :roughDiagItem="roughDiagItem"
            :taiouDispType="roughDiagResult.roughDiag.taiouDispType"
            @emit-change-answer="emitChangeAnswer"
          ></RoughDiagAnswerItem>
        </div>
        <div class="l-min-memo">
          <div class="l-formGroup">
            <label class="l-formGroup__label">メモ</label>
            <textarea
              class="l-formGroup__textArea is-high"
              data-dl-input-translation="true"
              v-model="memo"
            ></textarea>
          </div>
        </div>
        <div class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-group">
            <div class="btn-basic is-noborder is-inlne js-cancel" @click="goRoughDiagList()"><a>一覧へ戻る</a></div>
            <div class="btn-basic is-inlne is-primary js-savebtn" @click="register()"><a>保存</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="l-fixedBar is-top" :class="{ 'is-up' : scrolled }">
      <div>
        <div>
          <p class="title">{{ roughDiagResult.roughDiag.title }}</p>
          <div class="answer_number mb-0">
            <div>回答数 {{ this.answeredCount }}/{{ this.totalCount }} {{ progress }}% <div class="progress_bar"><span :style="'width: ' + progress + '%'"></span></div></div>
          </div>
        </div>
        <div>
          <div class="btn-cancel is-inlne js-cancel"><a @click="goRoughDiagList()">一覧へ戻る</a></div>
          <div class="btn-basic is-inlne is-primary js-savebtn" @click="register()"><a>保存</a></div>
        </div>
      </div>
    </div>
    <transition name="roughdiagachive-fade">
      <div class="l-modal" :class="{ 'is-show' : isAchieved }">
        <div class="l-modal__msgBox l-system-msg l-greenBox" style="padding: 0;background-color: transparent;text-align: center;">
          <div class="l-min-complete">
            <div class="l-min-complete__bg"><img src="@/assets/img/min/min-comp-bg.svg" width="600" height="300"></div>
            <div class="l-min-complete__title"><img src="@/assets/img/min/min-comp-title.svg" width="415" height="88"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import RoughDiagAnswerItem from '@/components/parts/rough_diag/RoughDiagAnswerItem.vue';
import DiagCorpHeader from '@/components/parts/diag/DiagCorpHeader.vue';

export default {
  components: {
    Loading,
    RoughDiagAnswerItem,
    DiagCorpHeader,
  },
  data() {
    return {
      isParamAccess: false,
      isProcessing: false,
      scrolled: false,
      isAchieved: false,
      isAdmin: false,
      isDiagAvailablePlan: false,
      roughDiagResult: {
        roughDiagResultId: null,
        corpId: null,
        roughDiagId: null,
        roughDiag: {
          title: '',
          description: '',
          roughDiagItems: [
            {
              checkItem: '',
              roughDiagResultItem: {
                answer: null,
              }
            }
          ]
        }
      },
      isAnswerChanged: false,
      memo: null,
    }
  },
  computed: {
    roughDiagId() {
      return this.$store.getters['diag/getRoughDiagId'];
    },
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    answeredCount() {
      let arr = this.roughDiagResult.roughDiag.roughDiagItems.filter(item => {
        return ((item.roughDiagResultItem.answer) && item.roughDiagResultItem.answer != 2);
      });
      return arr.length;
    },
    totalCount() {
     return this.roughDiagResult.roughDiag.roughDiagItems.length;
    },
    progress() {
      return Math.floor((this.answeredCount / this.totalCount) * 100);
    },
    corpName() {
      return this.$store.getters['diag/getCorpName'];
    },
    corporateFeatureInfoLabels() {
      return this.$store.getters['diag/getCorporateFeatureInfoLabels'];
    },
    manageCorpName() {
      return this.$store.getters['auth/getUser'].manageCorpNm;
    },
  },
  // corpIdの監視　法人切替時に実行される
  watch: {
    async corpId() {
      if ( !this.isParamAccess ) {
        // Paramアクセス出ない場合は、List画面に遷移する
        this.$store.dispatch('diag/setRoughDiagId', null);
        this.$router.push({ name: 'rough-diag-list' });
      }

    }
  },
  created: async function() {
    window.addEventListener("scroll", this.handleScroll);

    this.isProcessing = true;

    // パラメータURLからのアクセスかどうかをフラグ値にする
    this.isParamAccess = ( this.$route.params.corpId != undefined && this.$route.params.roughDiagId != undefined );

    if (this.isParamAccess) {
      this.$store.dispatch('diag/setRoughDiagId', this.$route.params.roughDiagId);
      this.$store.dispatch('diag/setCorpId', this.$route.params.corpId);
      this.$store.dispatch('diag/setDiagResultId', null);
      this.$store.dispatch('diag/setDiagResultItemId', null);

      // パラメータのチェック
      await this.checkParams(this.$route.params);
    }else{
      await this.getRoughDiagAnswer(this.roughDiagId);
      const authority = await this.$store.dispatch('auth/getAuthority')
      this.isAdmin = authority.isAdmin;
      this.isDiagAvailablePlan = authority.isDiagAvailablePlan;

      this.isParamAccess = false;
      this.isProcessing = false;
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!to.query.usertype && this.isAnswerChanged) {
      const answer = window.confirm("編集中のものは保存されませんが、よろしいですか？")
      next(answer)
    } else {
      next();
    }
  },
  methods: {
    async checkParams(params) {
      let res = await this.$axios.post('/ld/api/diag/roughDiag/checkParams', {
        corpId: params.corpId,
        roughDiagId: params.roughDiagId,
      });
      if (res.status===500){
        let res = await this.$axios.post('/ld/api/corporate/getClientCorporateList', {});
        if (res) {
          this.isProcessing = false;
　　      this.$store.dispatch('diag/setCorpId', res.data.corporateList[0].corpId);
          this.$store.dispatch('diag/setRoughDiagId', null);
          this.$toast.error('小テスト情報が見つからなかったので、Top画面に戻ります。');
          this.$router.push({ name: 'rough-diag-list' });
        }
      }else{
        await this.getRoughDiagAnswer(this.roughDiagId);
        await this.getDataForParamAccess(this.corpId, this.roughDiagId);

        const authority = await this.$store.dispatch('auth/getAuthority')
        this.isAdmin = authority.isAdmin;
        this.isDiagAvailablePlan = authority.isDiagAvailablePlan;

        this.isParamAccess = false;
        this.isProcessing = false;
      }
    },
    async getRoughDiagAnswer(roughDiagId) {
      let res = await this.$axios.post('/ld/api/diag/roughDiag/getRoughDiagAnswer', {
        roughDiagId: roughDiagId,
        corpId: this.corpId,
      });
      if (res) {
        this.roughDiagResult = res.data.roughDiagResult;
        this.memo = res.data.memo;
      }
    },
    async register() {

      this.isProcessing = true;
      let roughDiagResultItems = this.roughDiagResult.roughDiag.roughDiagItems.map(item => item.roughDiagResultItem);
      let res = await this.$axios.post('/ld/api/diag/roughDiag/storeAnswer', {
        roughDiagResultId: this.roughDiagResult.roughDiagResultId,
        corpId: this.roughDiagResult.corpId,
        roughDiagId: this.roughDiagResult.roughDiagId,
        roughDiagResultItems: roughDiagResultItems,
        answeredCount: this.answeredCount,
        totalCount: this.totalCount,
        memo: this.memo
      });
      if (res.status === 200) {

        this.isAchieved = res.data.isAchieved ;

        if(this.roughDiagResult.roughDiag.taiouDispType=='1'){ //1:「はい」のときは表示しない
            this.isAchieved = false;
        }

        this.isAnswerChanged = false;
        this.roughDiagResult = res.data.roughDiagResult;
        if (this.isAchieved) {
          setTimeout(() => {
            this.isAchieved = false;
          }, 5000);
        } else {
          this.$toast.info('保存しました。');
        }
      } else {
        this.$toast.error(res.data.message);
      }
      this.isProcessing = false;
    },
    handleScroll() {
      this.scrolled = window.scrollY > 300;
    },
    closeAchievedMessage() {
      this.isAchieved = false;
    },
    emitSelectCorpList(params) {
      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);
    },
    goRoughDiagList() {
      this.$router.push({ name: 'rough-diag-list' });
    },
    emitChangeAnswer() {
      this.isAnswerChanged = true;
    },
    async getDataForParamAccess(corpId, roughDiagId) {
      if (corpId) {
        let res = await this.$axios.post('/ld/api/diag/roughDiag/getDataForParamAccess', {
          corpId: corpId,
          roughDiagId: roughDiagId,
        });
        if (res.status==200) {
          this.$store.dispatch('diag/setCorporateFeatureInfoLabels', res.data.corporateFeatureInfoLabels);
          this.$store.dispatch('diag/setCorpName', res.data.corpNm);
        }
      }
    },
  }
}

</script>

<style scoped>
.roughdiagachive-fade-enter-active {
  transition: all .3s ease;
}
.roughdiagachive-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.roughdiagachive-fade-enter, .roughdiagachive-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.roughdiagachive-fade-active {
  transition: opacity 3s;
}

.roughdiagachive-fade-leave {
  opacity: 1;
}

.roughdiagachive-fade-leave-to {
  opacity: 0;
}
</style>
